import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAlignRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutAlignRight"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM17 7H15.5V17H17V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutAlignRight;
